import React from 'react';
import { defaultFormText, titleMRClass } from "src/components/common/common";

interface KioskPillSwitchButtonFormProps {
  title?: string;
  titleWidth?: number;
  value: 'Y' | 'N';
  onChange: (name: string, newValue: 'Y' | 'N') => void;
  name: string;
  editable?: boolean;
  titleless?: boolean;
  wrapperOption?: {
    wrapperStyle?: string;
    titleStyle?: string;
    inputStyle?: string;
  };
}

export const KioskPillSwitchButtonForm: React.FC<KioskPillSwitchButtonFormProps> = ({
  title,
  titleWidth,
  value,
  onChange,
  name,
  editable = true,
  titleless = false,
  wrapperOption = {
    wrapperStyle: "w-[220px] min-w-[220px] mr-[10px] mb-[5px]",
    titleStyle: "w-[150px] min-w-[150px]",
    inputStyle: "w-[100px] min-w-[100px]"
  },
}) => {
  const isYes = value === 'Y';

  const handleToggle = () => {
    if (editable) {
      onChange(name, isYes ? 'N' : 'Y');
    }
  };

  return (
    <div className={`flex items-center h-[34px] ${defaultFormText} ${wrapperOption.wrapperStyle}`} style={titleWidth ? { width: 'max-content' } : undefined}>
      <p
        className={`${wrapperOption.titleStyle} form-title ${titleMRClass} ${titleless ? 'hidden' : ''}`}
        style={titleWidth ? { width: titleWidth, minWidth: titleWidth, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } : undefined}
        title={title}
      >
        {title}
      </p>
      <div className={`flex items-center ${wrapperOption.inputStyle} h-full`}>
        <button
          type="button"
          className={`flex h-[34px] w-[76px] min-w-[76px] items-center justify-between rounded-full border border-[#c7cfda] bg-transparent p-[3px] text-[14px] font-bold leading-none ${editable ? 'cursor-pointer' : 'cursor-not-allowed opacity-60'}`}
          onClick={handleToggle}
          aria-pressed={isYes}
          disabled={!editable}
        >
          <span className={`flex h-[28px] w-[28px] items-center justify-center rounded-full ${isYes ? 'bg-[#2f67ec] text-white shadow-sm' : 'bg-[#e3e8f0] text-[#a2aab5]'}`}>
            Y
          </span>
          <span className={`flex h-[28px] w-[28px] items-center justify-center rounded-full ${!isYes ? 'bg-white text-[#174a9b] shadow-sm ring-1 ring-inset ring-[#c7cfda]' : 'bg-[#e3e8f0] text-[#a2aab5]'}`}>
            N
          </span>
        </button>
      </div>
    </div>
  );
};
